import { lang } from '@umu/ukit-lang';
import { ELearnStatus, SESSION_TYPE } from './enum';
import ProgressDoneImg from './image/progress-done.png';
import ProgressPendingImg from './image/progress-pending.png';
import ProgressNoneImg from './image/progress-none.png';

export interface ISessionRenderItem {
  icon: string;
  text: string;
}
const getIconName = (type: number) => {
  return `course-type-${type}`;
};
export const SessionItemInfoOptions: {
  [key in SESSION_TYPE]: ISessionRenderItem;
} = {
  [SESSION_TYPE.SURVEY]: {
    icon: getIconName(SESSION_TYPE.SURVEY),
    text: lang('问卷'),
  },
  [SESSION_TYPE.ASK]: {
    icon: getIconName(SESSION_TYPE.ASK),
    text: lang('提问'),
  },
  [SESSION_TYPE.COMMENT]: {
    icon: getIconName(SESSION_TYPE.COMMENT),
    text: lang('讨论'),
  },
  [SESSION_TYPE.PHOTO]: {
    icon: getIconName(SESSION_TYPE.PHOTO),
    text: lang('拍照'),
  },
  [SESSION_TYPE.GAME]: {
    icon: getIconName(SESSION_TYPE.GAME),
    text: lang('游戏'),
  },
  [SESSION_TYPE.SIGN]: {
    icon: getIconName(SESSION_TYPE.SIGN),
    text: lang('签到'),
  },
  [SESSION_TYPE.MINI_COURSE]: {
    icon: getIconName(SESSION_TYPE.MINI_COURSE),
    text: lang('语音微课'),
  },
  [SESSION_TYPE.RAFFLE_DRAWING]: {
    icon: getIconName(SESSION_TYPE.RAFFLE_DRAWING),
    text: lang('抽奖'),
  },
  [SESSION_TYPE.EXAM]: {
    icon: getIconName(SESSION_TYPE.EXAM),
    text: lang('考试'),
  },
  [SESSION_TYPE.VIDEO]: {
    icon: getIconName(SESSION_TYPE.VIDEO),
    text: lang('视频'),
  },
  [SESSION_TYPE.LIVE]: {
    icon: getIconName(SESSION_TYPE.LIVE),
    text: lang('会议'),
  },
  [SESSION_TYPE.ARTICLE]: {
    icon: getIconName(SESSION_TYPE.ARTICLE),
    text: lang('文章'),
  },
  [SESSION_TYPE.DOCUMENT]: {
    icon: getIconName(SESSION_TYPE.DOCUMENT),
    text: lang('文档'),
  },
  [SESSION_TYPE.IMAGE_ARTICLE]: {
    icon: getIconName(SESSION_TYPE.IMAGE_ARTICLE),
    text: lang('图文'),
  },
  [SESSION_TYPE.HOMEWORK]: {
    icon: getIconName(SESSION_TYPE.HOMEWORK),
    text: lang('作业'),
  },
  [SESSION_TYPE.MEETING]: {
    icon: getIconName(SESSION_TYPE.MEETING),
    text: lang('会议'),
  },
  [SESSION_TYPE.LIVE_PRO]: {
    icon: getIconName(SESSION_TYPE.LIVE_PRO),
    text: lang('直播'),
  },
  [SESSION_TYPE.AI_AUDIO_SLIDES]: {
    icon: getIconName(SESSION_TYPE.AI_AUDIO_SLIDES),
    text: lang('AI微课'),
  },
  [SESSION_TYPE.PHASE_EVALUATION]: {
    icon: getIconName(SESSION_TYPE.PHASE_EVALUATION),
    text: lang('阶段点评'),
  },
};

// 支持设置时间的小节
export const SupportSubmissionTimeTypeList = [
  SESSION_TYPE.SURVEY,
  SESSION_TYPE.HOMEWORK,
  SESSION_TYPE.EXAM,
];

/**
 * 媒体类型的小节
 */
export const MediaSessionTypeList = [
  SESSION_TYPE.VIDEO,
  SESSION_TYPE.LIVE,
  SESSION_TYPE.LIVE_PRO,
  SESSION_TYPE.MINI_COURSE,
  SESSION_TYPE.AI_AUDIO_SLIDES,
];

export const LearnStatusIconMap = {
  [ELearnStatus.notLearn]: ProgressNoneImg,
  [ELearnStatus.learning]: ProgressPendingImg,
  [ELearnStatus.learned]: ProgressDoneImg,
};
